/**
 * SubmissionUnterlagenDialog — the Unterlagen-Vorschau list for one submission (P2 Placement Slice 8).
 * Each row opens the bytes endpoint in a new tab (submissionUnterlageUrl); a banner shows when the
 * list is a live preview (not yet versandt).
 */

import { Dialog } from '../administration/components';
import { apiClient } from '../../lib/api-client';
import { fileSize } from '../../lib/format';
import { SUBMISSION_ATTACHMENT_ART_LABELS, SUBMISSION_VORSCHAU_HINWEIS } from '@brokly/shared';
import type { SubmissionUnterlagenVorschauInfo } from '@brokly/shared';

export function SubmissionUnterlagenDialog({
  open,
  onClose,
  placementId,
  submissionId,
  submissionNumber,
  unterlagen,
}: {
  open: boolean;
  onClose: () => void;
  placementId: string;
  submissionId: string;
  submissionNumber: string;
  unterlagen: SubmissionUnterlagenVorschauInfo[];
}) {
  const anyVorschau = unterlagen.some((u) => u.vorschau);
  return (
    <Dialog open={open} onClose={onClose} title={`Unterlagen ${submissionNumber}`}>
      <div data-testid="sub-unterlagen-dialog" />
      {anyVorschau && (
        <p className="mb-2 rounded-md border border-status-warning-border bg-status-warning-bg p-2 text-xs text-status-warning" role="note">
          {SUBMISSION_VORSCHAU_HINWEIS}
        </p>
      )}
      <ul className="flex flex-col gap-1">
        {unterlagen.map((u) => (
          <li key={u.art} className="flex items-center justify-between gap-3 rounded-md border border-border p-2 text-sm">
            <span className="flex flex-col">
              <span>{SUBMISSION_ATTACHMENT_ART_LABELS[u.art]}</span>
              <span className="text-xs text-muted-foreground">
                {u.filename}
                {u.size_bytes !== null ? ` · ${fileSize(u.size_bytes)}` : ''}
              </span>
            </span>
            {u.hidden_reason === 'permission' ? (
              <span className="text-xs text-muted-foreground" data-testid={`sub-unterlage-hidden-${u.art}`}>
                keine Berechtigung
              </span>
            ) : (
              <a
                className="text-sm text-primary underline"
                href={apiClient.placements.submissionUnterlageUrl(placementId, submissionId, u.art)}
                target="_blank"
                rel="noopener"
                data-testid={`sub-unterlage-link-${u.art}`}
              >
                {u.vorschau ? 'Vorschau' : 'Öffnen'}
              </a>
            )}
          </li>
        ))}
      </ul>
    </Dialog>
  );
}
